<footer class="footer">
  <div class="container">
    <div class="f-grid">
      <!-- Columna 1 -->
      <div class="f-col">
        <ng-container *ngFor="let g of col1">
          <h6 class="f-title">{{ g.title }}</h6>
          <ul class="f-links">
            <li *ngFor="let l of g.links">
              <a *ngIf="l.routerLink" [routerLink]="l.routerLink" class="f-link">{{ l.label }}</a>
              <a *ngIf="l.href" [href]="l.href" [target]="l.target || '_self'" class="f-link">{{ l.label }}</a>
            </li>
          </ul>
        </ng-container>
      </div>

      <!-- Columna 2 -->
      <div class="f-col">
        <ng-container *ngFor="let g of col2">
          <h6 class="f-title">{{ g.title }}</h6>
          <ul class="f-links">
            <li *ngFor="let l of g.links">
              <a *ngIf="l.routerLink" [routerLink]="l.routerLink" class="f-link">{{ l.label }}</a>
              <a *ngIf="l.href" [href]="l.href" [target]="l.target || '_self'" class="f-link">{{ l.label }}</a>
            </li>
          </ul>
        </ng-container>
      </div>

      <!-- Columna 3 -->
      <div class="f-col">
        <h6 class="f-title">{{ soporte.title }}</h6>
        <ul class="f-links">
          <li *ngFor="let l of soporte.links">
            <a *ngIf="l.routerLink" [routerLink]="l.routerLink" class="f-link">{{ l.label }}</a>
            <a *ngIf="l.href" [href]="l.href" [target]="l.target || '_self'" class="f-link">{{ l.label }}</a>
          </li>
        </ul>

        <h6 class="f-title mt">Redes sociales</h6>
        <div class="social">
          <a  href="https://www.facebook.com/AlphatecScientific" aria-label="Facebook" target="_blank" class="social__btn" title="Facebook">
            <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path fill="currentColor" d="M13 22v-9h3l1-4h-4V7a1 1 0 011-1h3V2h-3a5 5 0 00-5 5v2H6v4h3v9h4z"/></svg>
          </a>
          <a href="#" aria-label="LinkedIn" class="social__btn" title="LinkedIn">
            <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path fill="currentColor" d="M6.94 6.5A2.44 2.44 0 114.5 4.06 2.45 2.45 0 016.94 6.5zM4.75 8.5h4.38V21H4.75zM13.25 8.5H9.03V21h4.22v-6.6c0-1.75.33-3.44 2.5-3.44 2.13 0 2.16 1.99 2.16 3.55V21h4.22v-7.45c0-3.69-.79-6.55-5.06-6.55-2.06 0-3.44 1.13-4 2.2h-.04z"/></svg>
          </a>
          <a href="#" aria-label="YouTube" class="social__btn" title="YouTube">
            <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path fill="currentColor" d="M23 12s0-3.4-.44-5.04A3 3 0 0020.9 4.2C18.9 3.9 12 3.9 12 3.9s-6.9 0-8.9.3A3 3 0 001.44 6.96C1 8.6 1 12 1 12s0 3.4.44 5.04a3 3 0 001.66 2.76c2 .3 8.9.3 8.9.3s6.9 0 8.9-.3a3 3 0 001.66-2.76C23 15.4 23 12 23 12zM9.75 15.5v-7l6 3.5z"/></svg>
          </a>
          <a href="#" aria-label="Instagram" class="social__btn" title="Instagram">
            <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path fill="currentColor" d="M7 2h10a5 5 0 015 5v10a5 5 0 01-5 5H7a5 5 0 01-5-5V7a5 5 0 015-5zm5 5a5 5 0 105 5 5 5 0 00-5-5zm0 8.2A3.2 3.2 0 1115.2 12 3.2 3.2 0 0112 15.2zM18 6.8a1.2 1.2 0 101.2 1.2A1.2 1.2 0 0018 6.8z"/></svg>
          </a>
        </div>

        <h6 class="f-title mt">Valores y políticas</h6>
        <ul class="f-links">
          <li *ngFor="let p of politicas">
            <a *ngIf="p.routerLink" [routerLink]="p.routerLink" class="f-link">{{ p.label }}</a>
            <a *ngIf="p.href" [href]="p.href" [target]="p.target || '_self'" class="f-link">{{ p.label }}</a>
          </li>
        </ul>

        <h6 class="f-title mt">Recibe noticias</h6>
        <form class="newsletter" (submit)="onSubscribe($event)">
          <input type="email" required placeholder="Correo electrónico">
          <button type="submit">Suscribirme</button>
        </form>

        <h6 class="f-title mt">Certificaciones</h6>
        <div class="certs">
          <!-- <span class="cert-badge">CE</span>
          <span class="cert-badge">ISO</span>
          <span class="cert-badge">Q</span>
          <span class="cert-badge">Perú</span> -->
          <img src="assets/footer/cer5.png" alt="">
        </div>
      </div>
    </div>

    <!-- Pie inferior -->
    <div class="f-bottom">
      <div>© {{year}} ALPHATEC SCIENTIFIC® · Todos los derechos reservados</div>
      <nav class="f-bottom__nav">
        <a routerLink="/nosotros">Nosotros</a>
        <a routerLink="/contacto">Contacto</a>
        <a routerLink="/terminos">Términos</a>
        <a routerLink="/privacidad">Privacidad</a>
      </nav>
    </div>
  </div>

  <!-- Botón Volver Arriba (flotante) -->
  <button
    type="button"
    class="backtop"
    *ngIf="showTop"
    (click)="backToTop()"
    aria-label="Volver arriba">
    <!-- <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
      <path fill="currentColor" d="M12 4l-7 7h4v9h6v-9h4z"/>
    </svg> -->
    <i class="bi bi-caret-up"></i>
  </button>
</footer>
